import React, { FC } from 'react';
import styled from 'styled-components';
import { Chip, ChipProps, chipTheme } from '@clds/chip';
import Tooltip from '@clds/tooltip';

const StyledChip = styled(Chip)`
  max-width: calc(100% - ${chipTheme.rightSlotSpacing});
`;

export const ChipWithTooltip: FC<React.PropsWithChildren<ChipProps>> = ({ label, ...rest }) => (
  <StyledChip
    {...rest}
    label={
      <Tooltip title={label}>
        <Tooltip.OverflowTrigger>{label}</Tooltip.OverflowTrigger>
      </Tooltip>
    }
  />
);
